export async function parseResponse(response) {
    const raw = await response.text();

    try {
      return raw ? JSON.parse(raw) : raw;
    } catch {
      return raw;
    }
  }